import {Component, OnInit} from '@angular/core';
import {Ship} from '../../Ship';
import {ShipsContact} from '../../data/ShipsContact';
import {ShipService} from '../../services/ship.service';
import {EntitlementService} from '../../services/entitlement.service';
import {Router} from '@angular/router';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import * as customValidator from '../../validators/ship-validator';
import {MessageService} from 'src/app/services/message.service';
import {Address} from '../../data/Address';
import {EmvBulkAddress} from '../../data/EmvBulkAddress';

@Component({
  selector: 'app-ship-contacts',
  templateUrl: './ship-contacts.component.html',
  styleUrls: ['./ship-contacts.component.css']
})
export class ShipContactsComponent implements OnInit {
  ship: Ship;
  shipResultArray: Ship[];
  shipsContact: ShipsContact;
  stripDOStatus: string;
  stripDOCircle: string;
  save_do_btn =  false;
  save_do_btn_spinner: string;
  stripLSRStatus: string;
  save_lsr_btn = false;
  save_lsr_btn_spinner: string;
  stripBAStatus: string;
  stripEBAStatus: string;
  save_ba_btn = false;
  save_ba_btn_spinner: string;
  save_eba_btn = false;
  save_eba_btn_spinner: string;
  disboForm: UntypedFormGroup;
  lsrForm: UntypedFormGroup;
  bulkAddressForm: UntypedFormGroup;
  shipAddressForm: UntypedFormGroup;
  isStateShown: boolean = true;
  defaultCountry = 'US';

  constructor(private shipService: ShipService,
              private entitlementService: EntitlementService,
              private router: Router,
              private messageService: MessageService) { }

  ngOnInit() {
    this.ship = this.shipService.retrieveShipProfile();
    this.shipResultArray = this.shipService.retieveAllShipProfileResults();
    if (this.ship == null) {
      this.router.navigate(['/shipProfiles']);
    }
    this.shipService.getShipContacts(this.ship.shipLocation).subscribe(
      (data: ShipsContact) => {
        this.shipsContact = data;
        this.initForms();
      },
      (error) => { console.log('Error getting ship contact: ' + error); }
    );
  }

  initForms() {
    this.disboForm = new UntypedFormGroup({
      'officer': new UntypedFormControl(this.shipsContact.disboName, [customValidator.disboNameValidator]),
      'phone': new UntypedFormControl(this.shipsContact.disboPhone, [customValidator.phoneValidator]),
      'email': new UntypedFormControl(this.shipsContact.disboEmail, [Validators.email])
    });
    this.disboForm.statusChanges.subscribe(
      (newStatus: string) => this.save_do_btn = (newStatus === 'INVALID')
    );

    this.lsrForm = new UntypedFormGroup({
      'contact': new UntypedFormControl(this.shipsContact.lsrContact, [customValidator.lsrContactValidator]),
      'phone': new UntypedFormControl(this.shipsContact.lsrPhone, [customValidator.phoneValidator])
    });
    this.lsrForm.statusChanges.subscribe(
      (newStatus: string) => this.save_lsr_btn = (newStatus === 'INVALID')
    );

    // numbers only
    const zipPattern = '^[0-9]*$';
    // numbers, alpha characters, spaces and dashes
    const addressPattern = '^[0-9A-Za-z\\s\\-]+$';
    // alpha characters, spaces and dashes
    const cityPattern = '^[A-Za-z\\s\\-]+$';

    this.bulkAddressForm = new UntypedFormGroup({
      'contactName': new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
      'company': new UntypedFormControl('', [Validators.maxLength(30)]),
      'addressLine1': new UntypedFormControl('', [Validators.required, Validators.maxLength(34), Validators.pattern(addressPattern)]),
      'addressLine2': new UntypedFormControl('', [Validators.maxLength(34), Validators.pattern(addressPattern)]),
      'addressLine3': new UntypedFormControl('', [Validators.maxLength(34), Validators.pattern(addressPattern)]),
      'city': new UntypedFormControl('', [Validators.required, Validators.maxLength(34), Validators.pattern(cityPattern)]),
      'state': new UntypedFormControl('', Validators.required),
      'zip': new UntypedFormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(zipPattern)]),
      'country': new UntypedFormControl('', [Validators.required])
    });

    if (this.shipsContact.emvBulkAddress) {
      this.bulkAddressForm.patchValue({contactName: this.shipsContact.emvBulkAddress.bulkContactName});
      this.bulkAddressForm.patchValue({company: this.shipsContact.emvBulkAddress.bulkCompany});
      this.bulkAddressForm.patchValue({addressLine1: this.shipsContact.emvBulkAddress.addressLine1});
      this.bulkAddressForm.patchValue({addressLine2: this.shipsContact.emvBulkAddress.addressLine2});
      this.bulkAddressForm.patchValue({addressLine3: this.shipsContact.emvBulkAddress.addressLine3});
      this.bulkAddressForm.patchValue({city: this.shipsContact.emvBulkAddress.city});
      this.bulkAddressForm.patchValue({state: this.shipsContact.emvBulkAddress.state});
      this.bulkAddressForm.patchValue({zip: this.shipsContact.emvBulkAddress.zip});

      if (this.shipsContact.emvBulkAddress.country === this.defaultCountry) {
        this.isStateShown = true;
        this.bulkAddressForm.patchValue({state: this.shipsContact.emvBulkAddress.state});
      } else {
        this.isStateShown = false;
        this.bulkAddressForm.get('state').setValue(this.shipsContact.emvBulkAddress.state, {
          onlySelf: true
        });
      }
      this.bulkAddressForm.patchValue({zip: this.shipsContact.emvBulkAddress.zip});
      this.bulkAddressForm.patchValue({country: this.shipsContact.emvBulkAddress.country});
      this.defaultCountry = this.shipsContact.emvBulkAddress.country;
    }

    this.shipAddressForm = new UntypedFormGroup({
      'addressLine1': new UntypedFormControl('', [Validators.required, Validators.maxLength(34), Validators.pattern(addressPattern)]),
      'addressLine2': new UntypedFormControl('', [Validators.maxLength(34), Validators.pattern(addressPattern)]),
      'addressLine3': new UntypedFormControl('', [Validators.maxLength(34), Validators.pattern(addressPattern)]),
      'city': new UntypedFormControl('', [Validators.required, Validators.maxLength(34), Validators.pattern(cityPattern)]),
      'state': new UntypedFormControl('', Validators.required),
      'zip': new UntypedFormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(zipPattern)])
    });

    if (this.shipsContact.address) {
      this.shipAddressForm.patchValue({addressLine1: this.shipsContact.address.addressLine1});
      this.shipAddressForm.patchValue({addressLine2: this.shipsContact.address.addressLine2});
      this.shipAddressForm.patchValue({addressLine3: this.shipsContact.address.addressLine3});
      this.shipAddressForm.patchValue({city: this.shipsContact.address.city});

      if(this.shipsContact.address.country === this.defaultCountry) {
        this.isStateShown = true;
        this.shipAddressForm.patchValue({state: this.shipsContact.address.state});
      } else {
        this.isStateShown = false;
        this.shipAddressForm.get('state').setValue(this.shipsContact.address.state, {
          onlySelf: true
        });
      }
      this.shipAddressForm.patchValue({zip: this.shipsContact.address.zip});
      this.shipAddressForm.patchValue({country: this.shipsContact.address.country});
    }
    this.shipAddressForm.statusChanges.subscribe(
      (newStatus: string) => this.save_ba_btn = (newStatus === 'INVALID')
    );
    this.bulkAddressForm.statusChanges.subscribe(
      (newStatus: string) => this.save_eba_btn = (newStatus === 'INVALID')
    );

    // Field validation by keystroke, fixes an issue where the angular reactive forms not validating
    // after page init.
    this.shipAddressForm.valueChanges.subscribe(value => {
      Object.keys(this.shipAddressForm.controls).forEach(field => {
        if (value[field] != null && value[field] !== '') {
          const control = this.shipAddressForm.get(field);
          control.markAsTouched({onlySelf: true});
        }
      });
    });

    this.bulkAddressForm.valueChanges.subscribe(value => {
      Object.keys(this.bulkAddressForm.controls).forEach(field => {
        if (value[field] != null && value[field] !== '') {
          const control = this.bulkAddressForm.get(field);
          control.markAsTouched({onlySelf: true});
        }
      });
    });

  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  onShipChange(newShip: Ship) {
    this.ship = newShip;
  }

  saveShipsContact() {
    this.save_do_btn_spinner = 'fa fa-spinner fa-spin';
    this.save_do_btn = true;

    const officer = this.disboForm.value['officer'] ? this.disboForm.value['officer'] : '';
    const email = this.disboForm.value['email'] ? this.disboForm.value['email'] : '';
    const phone = this.disboForm.value['phone'] ? this.disboForm.value['phone'] : '';

    this.shipService.updateShipContact(this.ship.shipLocation, officer, email, phone).subscribe(
      (data) => {
        this.save_do_btn_spinner = '';
        this.messageService.success('Updated Ship Contact Successfully');
        this.save_do_btn = false;
      },
      (error) => {
        this.save_do_btn_spinner = '';
        this.messageService.error(error.message);
        this.save_do_btn = false;
      }
    );
  }

  saveLSRContact() {
    this.save_lsr_btn_spinner = 'fa fa-spinner fa-spin';
    this.save_lsr_btn = true;

    const phone = this.lsrForm.value['phone'] ? this.lsrForm.value['phone'] : '';
    const contact = this.lsrForm.value['contact'] ? this.lsrForm.value['contact'] : '';

    this.shipService.updateShipLsrContact(this.ship.shipLocation, contact, phone).subscribe(
      () => {
        this.save_lsr_btn_spinner = '';
        this.messageService.success('Updated LSR Contact Successfully');
        this.save_lsr_btn = false;
      },
      (error) => {
        this.save_lsr_btn_spinner = '';
        this.messageService.error(error.message);
        this.save_lsr_btn = false;
      }
    );
  }

  saveShipAddress() {
    this.save_ba_btn_spinner = 'fa fa-spinner fa-spin';
    this.save_ba_btn = true;

    if (this.shipsContact.address == null) {
      this.shipsContact.address = new Address();
    }
    this.shipsContact.address.addressLine1 = this.shipAddressForm.value['addressLine1'];
    this.shipsContact.address.addressLine2 = this.shipAddressForm.value['addressLine2'];
    this.shipsContact.address.addressLine3 = this.shipAddressForm.value['addressLine3'];
    this.shipsContact.address.city = this.shipAddressForm.value['city'];
    this.shipsContact.address.state = this.shipAddressForm.value['state'];
    this.shipsContact.address.zip = this.shipAddressForm.value['zip'];

    this.shipService.updateShipBulkAddress(this.ship.shipLocation, this.shipsContact.address).subscribe(
      () => {
        this.stripBAStatus = '';
        this.save_ba_btn_spinner = '';
        this.messageService.success('Updated Address Successfully');
        this.save_ba_btn = false;
      },
      (error) => {
        this.stripBAStatus = '';
        this.save_ba_btn_spinner = '';
        this.messageService.error(error.message);
        this.save_ba_btn = false;      }
    );
  }

  saveBulkAddress() {
    this.disableEbaSaveButton();

    if (this.bulkAddressForm.valid) {
      if (this.shipsContact.emvBulkAddress == null) {
        this.shipsContact.emvBulkAddress = new EmvBulkAddress();
      }

      this.shipsContact.emvBulkAddress.bulkContactName = this.bulkAddressForm.value['contactName'];
      this.shipsContact.emvBulkAddress.bulkCompany = this.bulkAddressForm.value['company'];
      this.shipsContact.emvBulkAddress.addressLine1 = this.bulkAddressForm.value['addressLine1'];
      this.shipsContact.emvBulkAddress.addressLine2 = this.bulkAddressForm.value['addressLine2'];
      this.shipsContact.emvBulkAddress.addressLine3 = this.bulkAddressForm.value['addressLine3'];
      this.shipsContact.emvBulkAddress.city = this.bulkAddressForm.value['city'];
      this.shipsContact.emvBulkAddress.state = this.bulkAddressForm.value['state'];
      this.shipsContact.emvBulkAddress.zip = this.bulkAddressForm.value['zip'];
      this.shipsContact.emvBulkAddress.country = this.bulkAddressForm.value['country'];

      this.shipService.updateEmvBulkAddress(this.ship.shipLocation, this.shipsContact.emvBulkAddress).subscribe(
        () => {
          this.stripEBAStatus = '';
          this.messageService.success('Updated Bulk Mailing Address Successfully');
          this.enableEbaSaveButton();
        },
        (error) => {
          this.stripEBAStatus = '';
          this.messageService.error(error.message);
          this.enableEbaSaveButton();
        }
      );
    } else {
      // validate all form fields
      Object.keys(this.shipAddressForm.controls).forEach(field => {
        const control = this.shipAddressForm.get(field);
        control.markAsTouched({onlySelf: true});
      });
      this.enableEbaSaveButton();
    }
  }

  public onCountryChange(args: any): void {
    this.shipAddressForm.controls.state.setValue('');

    const country = this.shipAddressForm.value['country'];
    this.isStateShown = country === 'US';
  }

  public disableEbaSaveButton() {
      this.save_eba_btn_spinner = 'fa fa-spinner fa-spin';
      this.save_eba_btn = true;
  }

  public enableEbaSaveButton() {
      this.save_eba_btn_spinner = '';
      this.save_eba_btn = false;
  }

}
